import React, { FC, useState } from 'react';
import { PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { fetchContacts } from '../../store/contacts/actions/contacts';
import { Table } from '../../components/table/Table';
import { TablesNames } from '../../store/tables/tables-context';
import { ContactsFilter, IContactsFilter } from '../../components/contacts/ContactsFilter';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { IPaginationData } from '../../interfaces/funds';

export const ContactsList: FC = () => {
	const { t } = useTranslation();
	const { pathname, search } = useLocation();

	const [query, setQuery] = useState('');
	const [email, setEmail] = useState('');
	const [userId, setUserId] = useState('');

	const [contactsListData, setContactsListData] = useState<IPaginationData>(null);
	const [isContactsListLoading, setIsContactsListLoading] = useState<boolean>(true);

	const rowActions = (rowData): JSX.Element => {
		const path = `${pathname}/${rowData?.original?.id}`;

		return (
			<div className="text-center">
				<Link
					to={path}
					state={{ search }}
					className="text-muted fs-7 fw-bolder">
					View
				</Link>
			</div>
		);
	};

	const listener = async (searchParams: IContactsFilter): Promise<void> => {
		setIsContactsListLoading(true);

		let localSearchParams: IContactsFilter;

		if (Object.keys(searchParams).length) {
			localSearchParams = searchParams;

			setQuery(localSearchParams.query ?? '');
			setEmail(localSearchParams.email ?? '');
			setUserId(localSearchParams.userId ?? '');

		} else {
			localSearchParams = {
				pageSize: '10',
				pageNumber: '1',
			};
		}

		const data = await fetchContacts(localSearchParams);
		setContactsListData(data);

		setIsContactsListLoading(false);

	};

	return (
		<>
			<PageTitle breadcrumbs={[]}>{t('MENU.CONTACTS')}</PageTitle>

			<ContactsFilter
				query={query}
				email={email}
				userId={userId}
				setQuery={setQuery}
				setEmail={setEmail}
				setUserId={setUserId}
			/>

			<Table
				name={TablesNames.contactsTableData}
				data={contactsListData?.rows ?? []}
				isLoading={isContactsListLoading}
				totalItemCount={contactsListData?.totalItemCount}
				enableRowActions={true}
				rowActions={rowActions}
				actionColumnsSize={50}
				queryParamsListener={listener}
			/>
		</>
	);
};
